const React = require('react');
const FormControl = require('@material-ui/core/FormControl').default;
const InputLabel = require('@material-ui/core/InputLabel').default;
const Select = require('@material-ui/core/Select').default;
const selectProvider = require('../../../../../Select/provider');
const ArrowA = require("../../../../../../icons/ArrowA");

const Arrow = () => (
  <div className="layoutRow fhaC fvaC sq30 abs eN sr17 st50%-14">
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 5.46392e-08L-5.34503e-08 1.2228L5 6L10 1.2228L8.75 3.82475e-07L5 3.6L1.25 5.46392e-08Z" fill="black"/>
    </svg>
  </div>
)

module.exports = selectProvider((env) => {
  const _control = env.control || {};
  const {
    helperText,
    ...control
  } = _control;
  return (
    <div className="w rlv
      (f12|tc|w-i)>.MuiSelect-root
      (w)>.MuiFormControl-root
      c0.38-i>.MuiSelect-root.Mui-disabled
      (pv13|ph25|c0-i)>.MuiOutlinedInput-input
      pr60>.MuiOutlinedInput-input*2
      (bgF|ph5|f12|ff$3|fw4)>.MuiFormLabel-root
      (c0-i)>.MuiFormLabel-root:not[.Mui-error]
      (x20y17s100|x20y16s100@firefox)>.MuiInputLabel-formControl
      x20y-6s100(|@firefox)>.MuiInputLabel-outlined.MuiInputLabel-shrink
      bgF>.MuiSelect-select:focus
      (b1-i|olN|r9)>.*-notchedOutline
      (bc8)>:not[.Mui-error]>.*-notchedOutline
      (bc0)>.Mui-focused:not[.Mui-error]>.*-notchedOutline
      dn>.*-notchedOutline
    ">
      <FormControl
        {...control}
        className={'w ' + (control.className || '')}
        variant="outlined"
      >
        {/*<InputLabel*/}
        {/*  {...env.label}*/}
        {/*/>*/}
        <Select
          {...env.select}
          className="w"
          IconComponent={Arrow}
        />
      </FormControl>
    </div>
  );
});
